export const abroadInsuranceEnum = {
    SuccessPage: "SuccessPage",
    BannerClick: "BannerClick",
    BannerImp: "BannerImp",
    ApprovedInsuranceMessage:"ApprovedInsuranceMessage",
    InfoButtonLobby:"InfoButtonLobby",
    InsuranceExist :"InsuranceExist",
    InfoButtonHullSheli: "InfoButtonHullSheli",
    AnotherInsButton: "AnotherInsButton",
    PhoneField: "PhoneField",
    PhoneContinueButton :"PhoneContinueButton",
    Otp:"Otp",
    CellocmCusOffer :"CellocmCusOffer",
    CellocmCustomerOfferJoinButton : "CellocmCustomerOfferJoinButton"
  };
  